import { CustomerPoolEnum, CustomerStateEnum } from '../../api';
import { aiMentionCustomerApi } from '../../api/aiAssistant';
import { customerPoolMapping, customerStateMapping } from '../../constants';
import { useCompany } from '../../hooks/company';
import MentionTag, { MentionInfoRow } from './MentionTag';

interface Props {
  name: string;
  customerId: string;
}

/** 消息里的客户提及：渲染成客户名标签，hover 弹出客户信息卡 */
const MentionCustomer = ({ name, customerId }: Props) => {
  const { id: companyId } = useCompany();

  const load = async (): Promise<MentionInfoRow[] | null> => {
    const list = await aiMentionCustomerApi.lookup(companyId, [customerId]);
    const info = list.find((c) => String(c.customerId) === customerId);
    if (!info) {
      return null;
    }
    const rows: MentionInfoRow[] = [
      ['客户', info.name],
      ['星级', info.star == null ? '—' : `${info.star} 星`],
      ['状态', customerStateMapping[info.state as CustomerStateEnum] || info.state || '—'],
      ['客户池', customerPoolMapping[info.pool as CustomerPoolEnum] || info.pool || '—'],
      ['渠道', info.channel || '—'],
      ['业务员', info.ownerUserName || '—'],
      ['手机号', info.mobileMasked || '—'],
      ['最后跟进', formatTime(info.lastEventAt)],
    ];
    if (info.loanCount) {
      rows.push(['放款', `${info.loanCount} 笔 / ${info.loanSumYuan ?? 0} 元`]);
    }
    return rows;
  };

  return (
    <MentionTag
      label={name}
      color="#d46b08"
      background="rgba(250, 140, 22, 0.12)"
      cacheKey={`customer:${companyId}:${customerId}`}
      load={load}
      missingText="无权查看该客户信息或客户不存在"
    />
  );
};

/** 后端下发 LocalDateTime 的 toString（2024-01-01T09:00），只展示到分钟 */
function formatTime(value?: string | null) {
  if (!value) {
    return '从未跟进';
  }
  return value.replace('T', ' ').slice(0, 16);
}

export default MentionCustomer;
